




































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SingleImageUpload from '@/component/single-image-upload.vue';
import moment, { Moment } from 'moment';
import storage from 'baimahu/storage';
import { AxiosResponse } from 'axios';
const uuidv4 = require('uuid/v4');
const numeral = require('numeral');
const { VUE_APP_FCREST: FCREST, VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  activity: `${FCAPI}/shang/promotion/activity`, // 获取活动信息
  region: `${FCREST}/promotion/shang/region`, // 获取区域列表
  distribution: `${FCAPI}/shang/clerk`, // 获取分销员列表
  merchant_clerk: `${FCAPI}/shang/promotion/activity/clerk`, // 获取活动绑定的分销员信息
};
const SKETCH_MAX_LENGTH: number = 40;
const UPLOAD_DIR = {
  award_share_img: 'poster',
};

const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

interface Preview {
  visible: boolean;
  url: string;
}

function getPreview(url: string = '', visible: boolean = false): Preview {
  return {
    url,
    visible,
  };
}

// 校验必填项
interface Form {
  award_description: string; // 奖励说明
  award_share_img: string; // 分享海报
  award_number: string; // 浏览奖励
  apply_award_number: string; // 报名奖励
  region_id: any[]; // 活动区域
}
// 校验必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

// 必填项提示信息列表
function getValidatorMap(
  is_open_share: number,
  is_activity_area: number,
  has_browse_reward: boolean,
  has_apply_reward: boolean,
): { [field: string]: Validator } {
  const browse_reward: any[] = has_browse_reward ? [
    {
      field: 'award_number',
      validate: (value: string): boolean => !!value,
      message: '请输入浏览奖励',
    }
  ] : [];
  const apply_reward: any[] = has_apply_reward ? [
    {
      field: 'apply_award_number',
      validate: (value: string): boolean => !!value,
      message: '请输入报名奖励',
    },
  ] : [];
  const common: any[] = [
    {
      field: 'award_description',
      validate: (value: string): boolean => !!value,
      message: '请输入奖励说明',
    },
    ...browse_reward,
    ...apply_reward,
  ];
  const is_verification =
    is_open_share === 1
      ? is_activity_area === 1
        ? [
            ...common,
            {
              field: 'region_id',
              validate: (value: string[]): boolean => value.length > 0,
              message: '请选择活动区域',
            },
          ]
        : common
      : [];
  const list: any[] = [
    {
      field: 'award_share_img',
      validate: (value: string): boolean => !!value,
      message: '请上传分享海报',
    },
    ...is_verification,
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

@Component({
  components: {
    SingleImageUpload,
  },
})
export default class ConfigBase extends Vue {
  appid: any = '';
  activity_area_list: any = []; // 区域列表
  activity_area: boolean = true; // 是否限制区域发放奖励显示隐藏
  activity_id: any = '';
  config_form_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  clerk_table: any = [];
  clerk_id_list: any = []; // 已添加分销员的id字符串；
  delete_index: any = '';
  depend_on_region: number = 1; // 是否根据区域发送奖励 1依据，2不依据
  del_item_id: number = 0;
  form: any = {
    award_description: '',
    award_share_img: '',
    award_number: '',
    apply_award_number: '',
    region_id: [],
  };
  field_watch_list: (() => void)[] = [];
  is_loading: boolean = false;
  is_share_bonus: number = 1; // 是否启用分享奖励 1:启用 2:不启用
  is_show_delete_modal: boolean = false;
  is_show_select_modal: boolean = false;
  is_show_sell_tips_modal: boolean = false; // 是否展示直销模式的说明
  is_show_fission_tips_modal: boolean = false; // 是否展示无痕裂变模式的说明
  is_add_modal_loading: boolean = false; // 一级分销员翻页加载
  is_table: boolean = true; // 是否绑定分销关系显示隐藏
  modal_data: any = {};
  merchant_mobile: any = '';
  member_mobile: any = '';
  member_name: string = '';
  open_share_bonus: boolean = true; // 是否启动分享有现金奖励显示隐藏
  preview_image: string = '';
  poster_preview: Preview = getPreview();
  poster_qrcode: any = require('@/asset/img/activity/poster_qrcode.png');
  preview_visible: boolean = false;
  regi_list: any = [];
  selected_checked_list: any = [];
  selected_item: any = []
;  toggle_binding_clerk: any = 1; // 绑定分销员关系，1触发，2不触发
  table_data: any = {
    data: [],
  };
  table_id_list: any = [];
  toggle_sharing_bonus: number = 1; // 分享奖励，1触发，2不触发
  has_browse_reward: boolean = true;
  has_apply_reward: boolean = false;
  has_no_reward: boolean = false; // 两种奖励都不勾选是显示报错提示
  validatorMap: { [field: string]: Validator } = getValidatorMap(
    this.toggle_sharing_bonus,
    this.depend_on_region,
    this.has_browse_reward,
    this.has_apply_reward,
  );
  UPLOAD_DIR: any = UPLOAD_DIR;

  // 获取当前活动信息
  async getActivityInfo(id: any) {
    this.is_loading = true;
    const res = await this.$axios.get(`${API.activity}/${id}`);
    if (res.data.status !== 200) {
      this.is_loading = false;
      this.$message.error(res.data.message);
      return;
    }
    const reg = new RegExp('<br/>', 'g');
    const remote = res.data ? res.data.data : {};
    this.toggle_sharing_bonus = remote.toggle_sharing_bonus;
    if (this.toggle_sharing_bonus === 2) {
      this.toggle_binding_clerk = remote.toggle_binding_clerk;
    } else {
      this.toggle_binding_clerk = remote.toggle_binding_clerk;
    }
    if (this.toggle_sharing_bonus === 1) {
      this.depend_on_region = remote.depend_on_region; // 是否依据区域发送奖励 1依据2不依据'
      this.form = {
        award_description: remote.award_description
          ? remote.award_description.replace(reg, '\n')
          : '', // 奖励说明
        award_share_img: remote.award_share_img, //  // 奖励分享海报
        award_number:
          numeral(remote.award_number || 0)
            .divide(100)
            .value() || undefined, // 浏览奖励
        apply_award_number:
          numeral(remote.applying_award || 0)
            .divide(100)
            .value() || undefined, // 报名奖励
        region_id:
          this.depend_on_region === 1
            ? (this.form.region_id = remote.region_id
                .split(',')
                .map((item: string) => Number(item)))
            : [], // 区域id
      };
      this.has_browse_reward = remote.award_number > 0;
      this.has_apply_reward = remote.applying_award > 0;
      this.validatorMap = getValidatorMap(
        this.toggle_sharing_bonus,
        this.depend_on_region,
        this.has_browse_reward,
        this.has_apply_reward,
      );
    } else if (this.toggle_sharing_bonus === 2) {
      this.form = {
        award_share_img: remote.award_share_img
          ? (this.form.award_share_img = remote.award_share_img)
          : '', //  // 奖励分享海报
      };
    }
    if (remote.clerk_info) {
      this.table_data.data = this.table_data.data.concat(remote.clerk_info);
      // 分销表格数据
      this.table_data.data.forEach((item: any, index: any) => {
        this.clerk_table[index] = {};
        this.clerk_table[index].id = item.clerk_id;
        this.clerk_table[index].mobile = item.clerk_mobile;
        this.clerk_table[index].name = item.clerk_name;
        this.clerk_table[index].is_merchant = item.is_merchant;
        this.clerk_table[index].user_id = item.user_id;
        this.table_id_list.push(item.id);
      });
    }
    this.is_loading = false;
  }
  beforeSharePosterImgUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  @Watch('form')
  limit() {
    this.field_watch_list = _.map(
      this.validatorMap,
      (validator: Validator, field: string) =>
        this.$watch(`form.${field}`, (val: any) => {
          this.validate(field);
        }),
    );
  }
  @Watch('toggle_sharing_bonus')
  is_disabled() {
    if (this.toggle_sharing_bonus === 2) {
      this.toggle_binding_clerk = 2;
      this.is_table = false;
      return true;
    } else {
      this.toggle_binding_clerk = this.toggle_binding_clerk;
      this.is_table = this.is_table;
      return false;
    }
  }

  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }

  handlePreviewCancel() {
    this.preview_visible = false;
  }

  handleRegionChange(value: any = []) {
    this.form.region_id = value;
  }

  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
      return false;
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field]
      ? this.validatorMap[field].validate(form[field], form)
      : '';
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid
      ? ''
      : this.validatorMap[field].message;
    return is_valid;
  }

  // 更改模态窗在dom结构中的位置
  getPopupContainer() {
    return document.getElementById('config-third-wrapper');
  }

  // 预览贴上二维码的分享海报
  handlePosterPreview() {
    this.poster_preview = getPreview(this.form.Á, true);
  }

  handlePosterPreviewCancel() {
    this.poster_preview = getPreview();
  }

  // 是否启用现金奖励事件
  changeShare() {
    this.validatorMap = getValidatorMap(
      this.toggle_sharing_bonus,
      this.depend_on_region,
      this.has_browse_reward,
      this.has_apply_reward,
    );
  }

  // 是否限制区域
  changeArea() {
    this.validatorMap = getValidatorMap(
      this.toggle_sharing_bonus,
      this.depend_on_region,
      this.has_browse_reward,
      this.has_apply_reward,
    );
  }

  // 是否绑定分销关系事件
  bindChange(e: any) {
    if (e.target.value === 1) {
      this.toggle_binding_clerk = 1;
      this.is_table = true;
    } else {
      this.toggle_binding_clerk = 2;
      this.is_table = false;
    }
  }

  // 分销表格model框
  handModalChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.queryModal(next_page);
  }

  // 分销表格model框分页
  paginationOption(data: FcapiRemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  // 分销表格相关
  handleSelect(selectedRowKeys: any) {
    this.selected_checked_list = selectedRowKeys;
    this.modal_data.detail.forEach((item: any, index: any) => {
      this.selected_checked_list.forEach((item2: any) => {
        if (item.id === item2) {
          this.selected_item.push(item);
        }
      });
    });
    this.selected_item = Array.from(new Set(this.selected_item));
  }

  // 关闭分销model框
  closeModal() {
    this.selected_checked_list = [];
    this.member_name = '';
    this.member_mobile = '';
  }

  // 展示所有分销员
  async queryModal(page: number = 1) {
    this.is_add_modal_loading = true;
    const send_data: any = {
      current: page,
      name: this.member_name,
      mobile: this.member_mobile,
      level: 1,
      status: 1,
      limit: 5,
    };
    const res = await this.$axios.get(API.distribution, { params: send_data });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      this.is_add_modal_loading = false;
      return;
    }
    this.modal_data = res.data.data ? res.data.data : {};
    this.is_add_modal_loading = false;
  }

  // 展示所有分销员列表
  showSelectModal() {
    this.is_show_select_modal = true;
    this.queryModal();
  }

  // 点击操作删除分销员
  showDeleteModal(record: any) {
    this.is_show_delete_modal = true;
    this.table_data.data.forEach((item: any, index: any) => {
      if (item === record) {
        this.delete_index = index;
        this.del_item_id = record.clerk_id;
      }
    });
  }

  // 删除分销员弹框
  confirmDelete() {
    this.table_data.data.splice(this.delete_index, 1);
    this.clerk_id_list.forEach((item: any, index: number) => {
      if (+item === this.del_item_id) {
        this.clerk_id_list.splice(index, 1);
      }
    });
    this.clerk_table.forEach((item: any, index: number) => {
      if (item.id === this.del_item_id) {
        this.clerk_table.splice(index, 1);
      }
    });
    this.is_show_delete_modal = false;
  }

  // 添加分销员弹出弹框
  addMember() {
    this.is_show_select_modal = false;
    this.selected_item.forEach((item: any, index: any) => {
      this.selected_checked_list.forEach((item2: any) => {
        if (item.id === item2) {
          const put_data: any = {
            id: uuidv4(),
            clerk_id: item.id,
            clerk_mobile: item.user.mobile,
            clerk_name: item.name,
            user_id: item.user_id,
          };
          this.table_data.data.push(put_data);
        }
      });
    });
    this.table_data.data.forEach((item: any, index: any) => {
      this.clerk_table[index] = {};
      this.clerk_table[index].id = item.clerk_id;
      this.clerk_table[index].name = item.clerk_name;
      this.clerk_table[index].mobile = item.clerk_mobile;
      this.clerk_table[index].is_merchant = item.is_merchant;
      this.clerk_table[index].user_id = item.user_id;
    });
    this.clerk_id_list = this.selected_checked_list;
    this.closeModal();
  }

  // 搜索分销员
  searchMember() {
    this.queryModal();
  }

  onChangeBroese() {
    this.has_browse_reward = !this.has_browse_reward;
    this.has_no_reward = !this.has_apply_reward && !this.has_browse_reward;
    this.validatorMap = getValidatorMap(
      this.toggle_sharing_bonus,
      this.depend_on_region,
      this.has_browse_reward,
      this.has_apply_reward,
    );
  }

  onChangeApply() {
    this.has_apply_reward = !this.has_apply_reward;
    this.has_no_reward = !this.has_apply_reward && !this.has_browse_reward;
    this.validatorMap = getValidatorMap(
      this.toggle_sharing_bonus,
      this.depend_on_region,
      this.has_browse_reward,
      this.has_apply_reward,
    );
  }

  // 获取地区列表
  async getRegion() {
    const res = await this.$axios.get(`${API.region}?is_pagination=2`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const remote = res.data;
    const data = remote.data;
    this.activity_area_list = data;
  }

  // 获取商家信息
  async getMerchantClerk() {
    const res = await this.$axios.get(
      `${API.merchant_clerk}?activity_id=${this.activity_id}&is_bind=1`,
    );
    // 获取商家信息
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.clerk_id_list = [];
    this.clerk_id_list.push(res.data.data.id);
    const remote = res.data;
    const data = remote.data;
    this.table_data.data = data;
    // const item = {
    //   id: uuidv4(),
    //   clerk_id: data.id || '',
    //   clerk_mobile: data.mobile || '',
    //   clerk_name: data.name || '',
    //   is_merchant: 1,
    // };
    // this.table_data.data.unshift(item);
  }

  // 新增或者编辑完成操作，字段文档 https://thoughts.aliyun.com/workspaces/5eb25c965fc5590023c52510/docs/5f05653ecdb6dc0001d793ab#5f05750a7c46d50ac8f3ae3d
  async finish() {
    this.validatorMap = getValidatorMap(
      this.toggle_sharing_bonus,
      this.depend_on_region,
      this.has_browse_reward,
      this.has_apply_reward,
    );
    if (!this.validateCommit()) {
      return;
    }
    if (this.has_no_reward) {
      this.$message.error('请填入必填项');
      return;
    }
    const send_data: any = storage.getItem('activity:send:second') || {};
    if (this.toggle_sharing_bonus === 1) {
      send_data.toggle_sharing_bonus = this.toggle_sharing_bonus; // 是否开启分享奖励  1 开启 2 不开启
      send_data.award_description = this.form.award_description
        ? this.form.award_description.replace(/\n/g, '<br/>')
        : '';
      send_data.award_share_img = this.form.award_share_img;
      send_data.award_number = this.has_browse_reward ? this.form.award_number * 100 : '';
      if (this.depend_on_region === 1) {
        send_data.depend_on_region = this.depend_on_region; // 是否依据区域发送奖励 1 依据 2 不依据
        send_data.region_id =
          this.form.region_id.length > 0
            ? this.form.region_id.join(',')
            : undefined;
      } else {
        send_data.depend_on_region = this.depend_on_region;
      }
      send_data.toggle_applying_bonus = this.has_apply_reward ? 1 : 2;
      send_data.applying_award = this.has_apply_reward ? this.form.apply_award_number * 100 : '';
    } else {
      send_data.toggle_sharing_bonus = this.toggle_sharing_bonus;
      send_data.depend_on_region = 0;
      send_data.award_share_img = this.form.award_share_img || '';
    }
    if (this.is_table === true) {
      const clerk_id_list: any = [];
      this.table_data.data.forEach((item: any) => {
        clerk_id_list.push(item.clerk_id);
      });
      send_data.toggle_binding_clerk = this.toggle_binding_clerk; // 绑定分销员关系 1 绑定 2不绑定
      send_data.clerk_id_list = clerk_id_list || [];
      // send_data.clerk.shift();
    } else {
      send_data.toggle_binding_clerk = this.toggle_binding_clerk;
      send_data.clerk_id_list = [];
    }
    // this.send_data = send_data;
    // 判断是新增活动步骤还是编辑活动步骤
    // return;
    this.is_loading = true;
    if (!this.$route.query.activity_id) {
      // 新增活动
      const res = await this.$axios.post(API.activity, send_data);
      // 第三步新增活动请求
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.$message.success('创建成功');
      this.$router.push({
        path: '/activity/list',
      });
      this.is_loading = false;
      storage.removeItem('activity:send:first');
      storage.removeItem('activity:send:second');
    } else {
      // 编辑活动
      send_data.id = this.activity_id;
      const res = await this.$axios.put(
        `${API.activity}/${this.activity_id}?id=${this.activity_id}`,
        send_data,
      );
      // 第三步编辑活动请求
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.$message.success('编辑成功');
      this.$router.push({
        path: '/activity/list',
      });
      this.is_loading = false;
      storage.removeItem('activity:send:first');
      storage.removeItem('activity:send:second');
    }
  }

  async created() {
    this.validatorMap = getValidatorMap(
      this.toggle_sharing_bonus,
      this.depend_on_region,
      this.has_browse_reward,
      this.has_apply_reward,
    );
    const profile: any = storage.getItem('profile') || {};
    this.merchant_mobile = profile.mobile || '';
    await this.getRegion();
    if (this.$route.query.activity_id) {
      this.activity_id = this.$route.query.activity_id;
      await this.getActivityInfo(this.activity_id);
      await this.getMerchantClerk();
    }
  }

  beforeDestroy() {
    this.field_watch_list.forEach((unwatch: () => void) => unwatch());
  }
}
